import React, { FC, useEffect, useState } from 'react';
import {
    TextArea, Flex, Text, Divider, Heading
} from '@adobe/react-spectrum';
import find from 'lodash/find';

import { IComment } from '~/Scene/Ui/uiComments';
import { _engine } from '~/Services/Studio/studioScene';
import { getRandomString } from '~/Utils/math';
import '../../Scene/Ui/ui.sass';
import { Deletable } from '~/Components/Delete/deletable';

let currentHoveredComment: string;

interface CommentProps { engineComments: IComment[] }

const Comments: FC<CommentProps> = ({ engineComments }: CommentProps) => {
    const [comments, setComments] = useState<IComment[]>([]);

    useEffect(() => {
        _engine.removeAllComment();
        _engine.addComments(engineComments);
        setComments(_engine.comments);
    }, [engineComments]);

    useEffect(() => {
        _engine.onModelPicked((point) => {
            const newComment = {
                id: getRandomString(),
                author: 'Amy',
                date: new Date(),
                point,
                text: '',
            };
            _engine.addComment(newComment);
            setComments([..._engine.comments]);
        });
    }, []);

    const onCommentChange = (commentId: string, text: string) => {
        const comment: IComment = find(comments, (c) => c.id === commentId);
        comment.text = text;
        _engine.editComment(comment);
    };

    const onCommentDelete = (commentId: string) => {
        _engine.removeComment(commentId);
        setComments([..._engine.comments]);
    };

    const onCommentHovered = (commentId: string) => {
        if (commentId) {
            _engine.showComment(commentId);
            currentHoveredComment = commentId;
        } else if (currentHoveredComment) {
            _engine.hideComment(currentHoveredComment);
            currentHoveredComment = null;
        }
    };

    return (
        <Flex direction="column" gap="size-200">
            <Heading level={4} marginBottom="size-0" marginTop="size-0">Comments</Heading>
            <Divider />
            {comments.map((hp) => (
                <Deletable
                    title="comment"
                    onDelete={() => { onCommentDelete(hp.id); }}
                    key={hp.id}
                >
                    <div
                        onMouseEnter={() => onCommentHovered(hp.id)}
                        onMouseLeave={() => onCommentHovered(null)}
                    >
                        <Flex direction="column" gap="size-100">
                            <Text UNSAFE_className="naker-hover-author">{`@${hp.author} - ${hp.date.toLocaleDateString()}`}</Text>
                            <TextArea
                                width="100%"
                                defaultValue={hp.text || ''}
                                onChange={(v) => onCommentChange(hp.id, v)}
                            />
                        </Flex>
                    </div>

                </Deletable>
            ))}
        </Flex>
    );
};

export default Comments;
